import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import apiClient from "../../apiClient";
import MITTable from "../MITTable";
import MyTickets from "./MyTickets";
import MyJobs from "./MyJobs";
import '../../styles/navigation/Dashboard.css';

function MainDashboard() {
  const [totalStores, setTotalStores] = useState(0);
  const [totalNewHires, setTotalNewHires] = useState(0);
  const [totalNewHiresLM, setTotalNewHiresLM] = useState(0);
  const [employeeStatus, setEmployeeStatus] = useState({});
  const [terminatedLastMonth, setTerminatedLastMonth] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const location = useLocation();

  // Check for error message from navigation state
  useEffect(() => {
    if (location.state?.error) {
      setErrorMessage(location.state.error);
      // Clear the error from location state after displaying
      window.history.replaceState({}, document.title);
      // Auto-hide error after 10 seconds
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [location]);

  useEffect(() => {
    const fetchIndicators = async () => {
      try {
        const totalStoresResponse = await apiClient.get("/api/total-stores");
        setTotalStores(totalStoresResponse.data.totalStores);

        const totalNewHiresResponse = await apiClient.get(
          "/api/total-new-hires"
        );
        setTotalNewHires(totalNewHiresResponse.data.totalNewHires);

        const totalNewHiresLMResponse = await apiClient.get(
          "/api/new-hires-lm"
        );
        setTotalNewHiresLM(totalNewHiresLMResponse.data.totalNewHiresLM);

        const employeeStatusResponse = await apiClient.get(
          "/api/employee-status"
        );
        setEmployeeStatus(employeeStatusResponse.data);

        const terminatedLastMonthResponse = await apiClient.get(
          "/api/terminated-last-month"
        );
        setTerminatedLastMonth(terminatedLastMonthResponse.data);
      } catch (error) {
        console.error("Error fetching indicators data:", error);
      }
    };

    fetchIndicators();
  }, []);

  return (
    <div className="dashboard-page">
      <div className="dashboard">
        {/* Error Message Banner */}
        {errorMessage && (
          <div className="error-banner">
            <div className="error-content">
              <span className="error-icon">⚠️</span>
              <span className="error-text">{errorMessage}</span>
              <button
                className="error-close"
                onClick={() => setErrorMessage("")}
              >
                ×
              </button>
            </div>
          </div>
        )}

        {/* Indicators Section - HIDDEN */}
        {/*
        <div className="indicators-section">
          <div className="indicators-grid">
            <div className="indicator-card">
              <div className="indicator-value">{totalStores}</div>
              <h3 className="indicator-label">Total Stores</h3>
            </div>

            <div className="indicator-card">
              <div className="indicator-value">{totalNewHires}</div>
              <h3 className="indicator-label">Current Active Hires</h3>
              <span className="terminated-text">
                Total Hired Last Month {totalNewHiresLM}
              </span>
            </div>

            {[
              "Restaurant Manager",
              "Assistant Manager",
              "Shift Leader",
              "Crew Member",
            ].map((role) => (
              <div key={role} className="indicator-card">
                <div className="indicator-value">
                  {(employeeStatus[role]?.active || 0).toLocaleString()}
                </div>
                <h3 className="indicator-label">Active {role}s</h3>
                <span className="terminated-text">
                  Terminated Last Month:{" "}
                  {(terminatedLastMonth[role] || 0).toLocaleString()}
                </span>
              </div>
            ))}
          </div>
        </div>
        */}

        {/* Main Content Grid */}
        <div className="dashboard-grid">
          <div className="dashboard-card mit-card">
            <h3 className="section-title">Managers in Training</h3>
            <MITTable />
          </div>

          <div className="dashboard-card employee-chart-section">
            <h3 className="section-title">My Tickets</h3>
            <MyTickets />
          </div>

          <div className="dashboard-card bench-card">
            <h3 className="section-title">PIC Tracker Status</h3>
            <div className="pic-tracker-placeholder">
              <div className="placeholder-content">
                <span className="placeholder-icon">📊</span>
                <p>PIC Tracker Status</p>
                <span className="placeholder-text">Coming Soon</span>
              </div>
            </div>
          </div>

          <div className="dashboard-card tenure-chart-section">
            <h3 className="section-title">My Jobs</h3>
            <MyJobs />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainDashboard;
